import styled, {css} from 'react-emotion';

import {queries} from './mediaQueries';
import theme from './theme';

export const flex = css`
	display: flex;
`;

export const alignCenter = css`
	align-items: center;
`;

export const FlexChild = styled.div`
	${props => props.flex && css`
		flex: ${props.flex};
	`};
	${props => props.marginLeft && css`
		margin-left: ${props.marginLeft};
	`};
	${props => props.margin && css`
		margin: ${props.margin};
	`};
	${props => props.align && css`
		align: ${
    		props.align
		};
	`};
	${props => props.textAlign && css`
		text-align: ${
    		props.textAlign
		};
	`};
	${props => props.alignSelf && css`
		align-self: ${
    		props.alignSelf
		};
	`};
	// Calculate the height based on expected items in filter list
	// so that the view is not jumping that much
	${props => props.expectedItems && css`
        .multilist .list {
            background-color: #FFF;
            border: rgb(238, 238, 238) 2px solid;
            border-radius: 3px 3px 3px 3px;
            padding: 10px;
            height: calc(${props.expectedItems} * 30px + 24px)
        }
    `};
    
    // what is the pseudo-event for the blue box-shadow?
    // ${css`
    //     .multilist label:focus::before{
    //         background-color: red;
    //         box-shadow:  0 0 0 2px red;
    //     }
    // `};
    
	.multilist {
		/* This is just an anchor for the other inner classes */
	}
	
	.multilist .listItem {
		display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-grow: 1;
	}
	.multilist .listItem:hover {
		color:${theme.colors.primaryColor};
		font-weight: 500;
	}
`;

const Flex = styled.div`
	display: flex;

	${props => props.justifyContent && css`
		justify-content: ${props.justifyContent};
	`};
	${props => props.grow && css`
		flex-grow: ${props.grow};
	`};
	${props => props.responsive && queries.small`
		flex-direction: column;
	`};
	${props => props.direction && css`
		flex-direction: ${props.direction};
	`};
	${props => props.alignCenter && alignCenter};
	${props => props.flexWrap && css`
		flex-wrap: wrap;
	`};
	${props => props.flexWrapReverse && css`
		flex-wrap: wrap-reverse;
	`};
	${props => props.hidden && css`
		${queries.xLarge`
			display: none;
		`};
	`};
	${props => props.width && css`
		width: ${props.width}
	`};
	${props => props.alignItems && css`
		align-items: ${props.alignItems}

	`};

`;

export default Flex;



// WEBPACK FOOTER //
// ./src/styles/Flex.js